export default [
  {
    path: '/',
    name: 'Login',
    meta: { requiresAuth: false },
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/Top/TopIndex')
  },
  {
    path: '/M0001User',
    name: 'M0001User',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0001User/M0001UserIndex')
  },
  {
    path: '/M0101Branch',
    name: 'M0101Branch',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0101Branch/M0101BranchIndex')
  },
  {
    path: '/M0201Chapter',
    name: 'M0201Chapter',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0201Chapter/M0201ChapterIndex')
  },
  {
    path: '/M0201Chapters',
    name: 'M0201Chapters',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0201Chapters/M0201ChaptersIndex')
  },
  {
    path: '/M0202Title',
    name: 'M0202Title',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0202Title/M0202TitleIndex')
  },
  {
    path: '/M0203Question',
    name: 'M0203Question',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0203Question/M0203QuestionIndex')
  },
  {
    path: '/M0203QuestionEditForm',
    name: 'M0203QuestionEditForm',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0203Question/M0203QuestionEditForm')
  },
  {
    path: '/M0204Answer',
    name: 'M0204Answer',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0204Answer/M0204AnswerIndex')
  },
  {
    path: '/M0301CommissionSetting',
    name: 'M0301CommissionSetting',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0301CommissionSetting/M0301CommissionSettingIndex')
  },
  {
    path: '/M0302CommissionRecord',
    name: 'M0302CommissionRecord',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0302CommissionRecord/M0302CommissionRecordIndex')
  },
  {
    path: '/M0303CommissionPayment',
    name: 'M0303CommissionPayment',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0303CommissionPayment/M0303CommissionPaymentIndex')
  },
  {
    path: '/M0401Class',
    name: 'M0401Class',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0401Class/M0401ClassIndex')
  },
  {
    path: '/M0402ClassInstructor',
    name: 'M0402ClassInstructor',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0402ClassInstructor/M0402ClassInstructorIndex')
  },
  {
    path: '/M0403ClassStudent',
    name: 'M0403ClassStudent',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0403ClassStudent/M0403ClassStudentIndex')
  },
  {
    path: '/M0404ClassUnit',
    name: 'M0404ClassUnit',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0404ClassUnit/M0404ClassUnitIndex')
  },
  {
    path: '/M0405ClassUnitAttendant',
    name: 'M0405ClassUnitAttendant',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0405ClassUnitAttendant/M0405ClassUnitAttendantIndex')
  },
  {
    path: '/M0501Course',
    name: 'M0501Course',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0501Course/M0501CourseIndex')
  },
  {
    path: '/M0502CourseLevel',
    name: 'M0502CourseLevel',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0502CourseLevel/M0502CourseLevelIndex')
  },
  {
    path: '/M0503MaterialLicense',
    name: 'M0503MaterialLicense',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0503MaterialLicense/M0503MaterialLicenseIndex')
  },
  {
    path: '/M0601Instructor',
    name: 'M0601Instructor',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0601Instructor/M0601InstructorIndex')
  },
  {
    path: '/M0602Student',
    name: 'M0602Student',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0602Student/M0602StudentIndex')
  },
  {
    path: '/S0101DataImport',
    name: 'S0101DataImport',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/S0101DataImport/S0101DataImportIndex')
  },
  {
    path: '/AddQuestion',
    name: 'AddQuestion',
    meta: { requiresAuth: true },
    component: () => import('@/components/functions/M0201Chapters/AddQuestionToAll')
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js